var _path, _g, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNavIcon6(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 730.03 628.19",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m140.86 33.943c-41.335 0-64.571 21.371-64.571 65.036v450.12c0 40.843 20.891 62.228 62.192 62.228h452.02c41.303 0 62.226-20.32 62.226-62.228v-450.12c0-42.6-20.923-65.036-63.523-65.036 0 0-448.49-0.142-448.35 0h-1.5e-5z",
    stroke: "#fff"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "round",
    strokeWidth: 20
  }, /*#__PURE__*/React.createElement("path", {
    d: "m569.37 469.47v-300.81h-408.71v300.81h408.71z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m365.01 319.07"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m165.51 463.57l140.1-142.11"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m562.97 461.97l-136.45-138.6"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m165.46 172.49l176.32 178.67c13.069 13.17 36.848 13.014 49.641 0.12003l176.2-177.35",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 20
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavIcon6);
export default __webpack_public_path__ + "static/media/nav-icon6.a57004948d2ff3c984fd0548e4499e39.svg";
export { ForwardRef as ReactComponent };